import {Injectable} from "@angular/core";
import {AbstractControl} from "@angular/forms";
import {StringHelper} from "../helpers/strings.helper";


@Injectable()
export class FormValidationService {


  nameValidation(control: AbstractControl): { [key: string]: any } | null {
    let name = control.value;
    let isValid = StringHelper.validName(name);
    if (isValid) {
      return null;
    } else {
      return {'name': true};
    }
  }

  otpValidation(control: AbstractControl): { [key: string]: any } | null {
    let otp = control.value;
    let isValid = StringHelper.validOTP(otp);
    if (isValid) {
      return null;
    } else {
      return {'otp': true};
    }
  }

  numberValidation(control: AbstractControl): { [key: string]: any } | null {
    let num = control.value;
    let isValid = StringHelper.validNumber(num);
    if (isValid) {
      return null;
    } else {
      return {'number': true};
    }
  }

  bvnValidation(control: AbstractControl): { [key: string]: any } | null {
    let bvn = control.value;
    let isValid = StringHelper.validBVN(bvn);
    if (isValid) {
      return null;
    } else {
      return {'bvn': true};
    }
  }

  usernameValidation(control: AbstractControl): { [key: string]: any } | null {
    let username = control.value;
    let isValid = StringHelper.isValidUsername(username);
    if (isValid) {
      return null;
    } else {
      return {'username': true};
    }
  }

  emailValidation(control: AbstractControl): { [key: string]: any } | null {
    let email = control.value;
    let isValid = StringHelper.validEmail(email);
    if (isValid) {
      return null;
    } else {
      return {'email': true};
    }
  }

  pinValidation(control: AbstractControl): { [key: string]: any } | null {
    let pin = control.value;
    let isValid = StringHelper.validPin(pin);
    if (isValid) {
      return null;
    } else {
      return {'pin': true};
    }
  }

  passwordValidation(control: AbstractControl): { [key: string]: any } | null {
    let password = control.value;
    let isValid = StringHelper.validSecret(password);
    if (isValid) {
      return null;
    } else {
      return {'password': true};
    }
  }

  phoneNoValidation(control: AbstractControl): { [key: string]: any } | null {
    let phoneNumber = control.value;
    let isValid = StringHelper.validMobileNumber(phoneNumber);
    if (isValid) {
      return null;
    } else {
      return {'phoneNumber': true};
    }
  }

  cashInputValidation(control: AbstractControl): { [key: string]: any } | null {
    let cash = control.value;
    let isValid = StringHelper.validCashInput(cash);
    if (isValid) {
      return null;
    } else {
      return {'cashInput': true};
    }
  }

  accountNoNoValidation(control: AbstractControl): { [key: string]: any } | null {
    let accountNo = control.value;
    let isValid = StringHelper.validNuban(accountNo);
    if (isValid) {
      return null;
    } else {
      return {'account': true};
    }
  }

}
